import React, { useState } from 'react'
import {
  MDBBtn,
  MDBCol,
  MDBInput,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalBody,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow,
} from 'mdb-react-ui-kit'
import SubscriptionsStore from './../../../../Subscriptions.store'

export const DowngradeModal = props => {
  const { downgradeContent } = SubscriptionsStore
  const [state, setState] = useState({})

  const onChange = ({ target }) =>
    setState(prev => {
      return { ...(prev || {}), [target.name]: target.value }
    })

  return (
    <MDBModal className='downgrade-modal' open={props.showDowngradeModal} tabIndex='-1' onClose={props.toggle}>
      <MDBModalDialog size='lg'>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>{downgradeContent?.pageName}</MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={props.toggle}></MDBBtn>
          </MDBModalHeader>

          <MDBModalBody>
            <p>Are you sure you want to downgrade?</p>
            <div
              dangerouslySetInnerHTML={{
                __html: downgradeContent?.content,
              }}
            />
            <MDBRow className='mb-3'>
              <MDBCol size='12' md='6'>
                <MDBInput
                  label='Why are you downgrading today?'
                  type='textarea'
                  name='why_downgrade'
                  value={state?.why_downgrade || ''}
                  onChange={onChange}
                  validate
                />
              </MDBCol>
              <MDBCol size='12' md='6'>
                <MDBInput
                  label='What could USABG have done better?'
                  type='textarea'
                  name='what_better'
                  value={state?.what_better || ''}
                  onChange={onChange}
                  validate
                />
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol size='12' md='6'>
                <MDBBtn
                  type='button'
                  className='btn-block'
                  color='danger'
                  disabled={!(state.why_downgrade && state.what_better)}
                  onClick={() => props.downgrade(state)}
                >
                  Yes, I want to give up my benefits.
                  <br />
                  Downgrade my account.
                </MDBBtn>
              </MDBCol>
              <MDBCol size='12' md='6'>
                <MDBBtn type='button' className='btn-block' color='secondary' onClick={props.toggle}>
                  I&apos;d like to keep my benefits.
                  <br />
                  Let&apos;s keep my subscription.
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}
